"use strict";
$(function() {
  var $open, col, down, i, isOpen, j, k, l, max, ref, ref1, up;
  max = 12;
  col = $(window).width() > 490 ? 6 : 3;
  $open = '';
  isOpen = false;
  for (j = k = 0, ref = max / col; 0 <= ref ? k < ref : k > ref; j = 0 <= ref ? ++k : --k) {
    for (i = l = 0, ref1 = col; 0 <= ref1 ? l < ref1 : l > ref1; i = 0 <= ref1 ? ++l : --l) {
      $($('.prof')[j * col + i]).insertBefore($($('.thm')[(j + 1) * col]));
    }
  }
  $('.thm').on('click', function(e) {
    var $t;
    e.preventDefault();
    e.stopPropagation();
    $t = $("#" + ($(this).attr('href')));
    if (!isOpen) {
      return down($t);
    } else {
      if ($t.is(':visible')) {
        return up();
      } else {
        return down($t);
      }
    }
  }).each(function() {
    return $(this).attr('href', $(this).attr('href').substr(1));
  });
  $('body').on('click', function(e) {
    if (isOpen) {
      return up();
    }
  });
  down = function($t) {
    if (isOpen) {
      $open.css({
        position: 'absolute',
        top: $open.position().top
      });
      $open.fadeOut(200, function() {
        return $(this).css({
          position: 'relative',
          top: ''
        });
      });
      $open = $t.fadeIn(200);
    } else {
      $open = $t.slideDown(500);
    }
    $('.thm').removeClass('on').addClass('off');
    $(".thm[href='" + ($t.attr('id')) + "']").removeClass('off').addClass('on');
    return isOpen = true;
  };
  up = function() {
    $open.slideUp(300);
    $('.thm').removeClass('off');
    $(".thm[href='" + ($open.attr('id')) + "']").removeClass('on');
    isOpen = false;
    return $open = null;
  };
  if (location.hash !== '' && ($(location.hash) != null)) {
    setTimeout(function() {
      return down($(location.hash));
    }, 500);
  }
  return this;
});
